<template>
  <div class="underinfo">
    <!-- 顶部搜索 -->
    <div class="underinfo-top" style="">
      <!-- 所有、在线、离线 -->
      <div>
        <div v-if="this.who == 'setVipPermission'">
          <el-select
            @change="selectChange"
            v-model="select_value"
            placeholder="请选择卡类型"
          >
            <el-option
              v-for="item in select_option"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div style="display: flex">
        <el-input
          style="max-width: 500px"
          :placeholder="bs_place"
          v-model="search_value"
          class="input-with-select"
        >
        </el-input>
        <el-button
          style="margin-left: 20px"
          type="primary"
          slot="append"
          @click="reflashTable()"
        >
          重新获取</el-button
        ><el-button
          style="margin-left: 20px"
          type="primary"
          slot="append"
          @click="submit()"
        >
          审核全部</el-button
        >
      </div>
    </div>
    <!-- 底部表格 -->
    <div class="underinfo-btm">
      <ve-table
        id="dyhbasetable"
        v-if="ui_show"
        border-y
        :border-around="true"
        :fixed-header="true"
        row-key-field-name="rowKey"
        :checkbox-option="checkboxOption"
        :sort-option="sortOption"
        :max-height="scroll_height"
        :columns="underinfoColumn"
        :table-data="underinfo_list"
        :cell-style-option="cellStyleOption"
        :virtual-scroll-option="virtualScrollOption"
        enable="true"
      />
    </div>
  </div>
</template>
<script>
// import { getOnLineMerchant, getOfflinestoresList } from "@/api/service.js";
// import { bingAuditList } from "@/api/v2/merchant.js";
import { cellStyleOption } from "@/js/sheettablecolumn.js";
import { offlineBaseinfoGradelist } from "@/api/offlinestores.js";
export default {
  name: "dyh-basetable",
  props: ["who", "column", "tableData", "bs_place"],
  data() {
    return {
      select_value: "",
      select_option: [],
      ui_show: true, //表格是否显示
      virtualScrollOption: {
        // 是否开启虚拟滚动
        enable: true,
      },
      //单元格样式
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
        ...cellStyleOption,
      },
      checkboxOption: {
        /* // 行选择改变事件
        selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
          console.log(row, isSelected, selectedRowKeys);
        },
        // 全选改变事件
        selectedAllChange: ({ isSelected, selectedRowKeys }) => {
          console.log(isSelected, selectedRowKeys);
        } */
      },
      //线下店铺信息表格的列
      underinfoColumn: this.column,
      sortOption: {
        sortChange: (params) => {
          if (this.who == "setVipPermission") {
            this.sortChange(params);
          }
        },
      },

      /* <button
                  class="underinfo-button-primary"
                  on-click={() => this.editRow(rowIndex)}
                >

                </button>
                &nbsp; */
      //
      classList: ["所有", "在线", "离线"],
      ckeyWords: ["在线"],
      search_value: "", //input搜索值
      underinfo_list: [], //显示店铺
      all_underinfo_list: [], //所有店铺
      scroll_height: "", //表格高度
    };
  },
  watch: {
    innerWH: {
      handler(newinner, oldinner) {
        if (newinner.innerHeight < 700) {
          this.scroll_height = newinner.innerHeight - 180;
        } else {
          this.scroll_height = newinner.innerHeight - 210;
        }
      },
      deep: true,
      immediate: true,
    },
    search_value: {
      handler(newvr, oldv) {
        this.search();
      },
    },
  },
  computed: {
    innerWH() {
      return this.$store.state.resolution.innerWH;
    },
  },
  async mounted() {
    this.loadingInstance = this.$veLoading({
      target: "#dyhbasetable",
      overlayBackgroundColor: "rgba(255,255,255,.5)",
      name: "grid",
    });
    this.loadingInstance.show();
    // this.getShopList();
    this.getSelectOption();
  },
  methods: {
    selectChange(e) {
      this.$emit("setGrade", e);
    },
    /**
     * 搜索
     */
    search() {
      if (this.search_value == "") {
        this.underinfo_list = [];
        for (let i = 0; i < this.all_underinfo_list.length; i++) {
          this.underinfo_list.push({
            rowKey: i,
            ...this.all_underinfo_list[i],
          });
        }
        return;
      }
      let list = [];
      for (let i = 0; i < this.all_underinfo_list.length; i++) {
        try {
          if (
            this.who == "setVipPermission" &&
            this.all_underinfo_list[i].account_name.indexOf(this.search_value) >
              -1
          ) {
            //会员申请
            list.push(this.underinfo_list[i]);
          } else if (
            (this.who == "allvip" &&
              this.all_underinfo_list[i].name.indexOf(this.search_value) >
                -1) ||
            this.all_underinfo_list[i].card_id.indexOf(this.search_value) > -1
          ) {
            list.push(this.all_underinfo_list[i]);
          }
        } catch (e) {
          console.log(JSON.stringify(e));
        }
      }
      this.underinfo_list = [];
      this.underinfo_list = list;
    },
    sortChange(params) {
      this.underinfo_list.sort((a, b) => {
        if (params.create_time) {
          if (params.create_time === "asc") {
            return new Date(a.create_time) - new Date(b.create_time);
          } else if (params.create_time === "desc") {
            return new Date(b.create_time) - new Date(a.create_time);
          }
        } else {
          return new Date(a.rowKey) - new Date(b.rowKey);
        }
      });
    },
    /**
     * 暂时没用 通过key值 返回内容
     * @param {string} keywords
     */
    classChange(keywords) {
      this.ckeyWords = [];
      this.ckeyWords.push(keywords);
      this.underinfo_list = [];
      switch (keywords) {
        case "所有":
          this.underinfo_list = this.all_underinfo_list;
          break;
        case "在线":
          try {
            for (let i = 0; i < this.all_underinfo_list.length; i++) {
              if (this.all_underinfo_list[i].class_state == "7") {
                this.underinfo_list.push(this.all_underinfo_list[i]);
              }
            }
          } catch (e) {
            this.warnMessage(JSON.stringify(e));
            console.log(e);
          }

          break;
        case "离线":
          for (let i = 0; i < this.all_underinfo_list.length; i++) {
            if (this.all_underinfo_list[i].class_state == "0") {
              this.underinfo_list.push(this.all_underinfo_list[i]);
            }
          }
          break;
      }
    },
    editRow() {
      console.log("this.editRow");
    },
    deleteRow() {
      console.log("this.deleteRow");
    },
    submit() {
      this.$emit("submit", "");
    },
    reflashTable() {
      this.$emit("reflashTable", "");
      this.loadingInstance.show();
    },
    async getShopList(tableData) {
      this.underinfo_list = tableData;
      this.all_underinfo_list = tableData;
      this.loadingInstance.close();
      return;
      this.underinfo_list = [];
      this.all_underinfo_list = [];
      // const aduitlist = await bingAuditList();

      // this.underinfo_list = aduitlist;
      for (let i = 0; i < aduitlist.length; i++) {
        this.underinfo_list.push({
          rowKey: i,
          ...aduitlist[i],
        });
        this.all_underinfo_list.push({
          rowKey: i,
          ...aduitlist[i],
        });
      }
      /*  //所有店铺
      const ls = await getOfflinestoresList();
      for (let i = 0; i < ls.length; i++) {
        this.underinfo_list.push({
          rowKey: i,
          merchant_id: ls[i].merchant_id,
          merchant_name: ls[i].merchant_name,
          class_state: "0"
        });
      }

      // console.log(this.underinfo_list);
      this.ui_show = false;
      setTimeout(async () => {
        const list = await getOnLineMerchant();
        for (let j = 0; j < this.underinfo_list.length; j++) {
          for (let i = 0; i < list.length; i++) {
            if (this.underinfo_list[j].merchant_id == list[i].merchant_id) {
              this.underinfo_list[j] = {
                ...this.underinfo_list[j],
                class_state: "7",
                ...(list[i] ? list[i] : "")
              };
            }
          }
        }
        this.ui_show = true;
        this.all_underinfo_list = this.underinfo_list;
        this.classChange(this.ckeyWords[0]);
      }, 100);
 */
      //
    },
    async getSelectOption() {
      if (this.who == "setVipPermission") {
        // this.select_option
        let list = await offlineBaseinfoGradelist();
        for (let i = 0; i < list.length; i++) {
          this.select_option.push({
            label: list[i].name,
            value: list[i].classify_no,
          });
        }
        this.select_value = this.select_option[0].value;
        this.selectChange(this.select_value);
      }
    },
  },
};
</script>

<style lang="less">
.table-header-cell-class {
  background: #409eff !important;
  color: #fff !important;
}
.underinfo-top {
  display: flex;
  justify-content: space-between;
  &-l-f {
    display: flex;
    align-items: center;
    width: calc(100% - 285px);
    height: 40px;
    scrollbar-width: none;
    padding: 0 10px 0 0;
    &-span {
      margin: 0 10px 0 0;
      color: #606266;
      cursor: pointer;
    }
    &-clicked {
      color: #409eff;
      font-weight: 700;
    }
  }
}
.underinfo {
  width: 100%;
  height: 100%;
}
.underinfo-btm {
  width: 100%;
  margin-top: 10px;
}
.underinfo-button-primary {
  background-color: #409eff;
  color: #fff;
  width: 80px;
}
.underinfo-button-err {
  background-color: rgb(255, 0, 0);
  min-height: 30px;
  width: 80px;
  color: #fff;
}
</style>
